import { tap, finalize } from 'rxjs';

import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthStore } from '@/app/core/store/auth';
import { AuthService, LoginPayload, CredentialsInfo, LoginConfirmPayload } from '@/app/api/auth';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private TOKEN_COOKIE_KEY = 'token';

  constructor(
    private router: Router,
    private authStore: AuthStore,
    private authService: AuthService,
  ) {}

  getToken() {
    return localStorage.getItem(this.TOKEN_COOKIE_KEY);
  }

  private _deleteCredentials() {
    localStorage.removeItem(this.TOKEN_COOKIE_KEY);
    this.authStore.setAuthUser(null);
  }

  private _saveToken(token: string) {
    localStorage.setItem(this.TOKEN_COOKIE_KEY, token);
  }

  private _saveCredentials(data: CredentialsInfo) {
    this.authStore.setAuthUser(data.user);
    this._saveToken(data.token);
  }

  login(payload: LoginPayload) {
    return this.authService.login(payload);
  }

  loginConfirm(payload: LoginConfirmPayload) {
    return this.authService.loginConfirm(payload).pipe(
      tap((credentialInfo) => {
        this._saveCredentials(credentialInfo);
      }),
    );
  }

  navigateToLogin() {
    this._deleteCredentials();
    this.router.navigate(['/auth/login']);
  }

  logout() {
    return this.authService.logout().pipe(finalize(() => this.navigateToLogin()));
  }

  refreshToken() {
    return this.authService.refreshToken().pipe(tap((response) => this._saveToken(response.token)));
  }
}
